import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { FocusOn } from 'react-focus-on';

import usePositionEmojiPicker from '../hooks/usePositionEmojiPicker';

import EmojiPicker from './emojiPicker';

import styles from '../styles/emojiPickerWrapper.module.scss';

const EmojiPickerWrapper = ({
  closePicker = () => {},
  isActive = false,
  onEmojiSelect = () => {},
  target = null,
}) => {
  const ref = useRef(null);

  usePositionEmojiPicker({ ref, target });

  if (!isActive) return null;

  const handleEmojiSelect = (emoji) => {
    onEmojiSelect(emoji);
    closePicker();
  };

  const handleClickOutside = (event) => {
    if (
      ref.current &&
      !ref.current.contains(event.target) &&
      !(target && target.contains(event.target))
    ) {
      closePicker();
    }
  };

  return (  
    <FocusOn className={styles.element} returnFocus scrollLock={false}>
      <div ref={ref}>
        <EmojiPicker
          className={styles.picker}
          closePicker={closePicker}
          isActive
          onClickOutside={handleClickOutside}
          onEmojiSelect={handleEmojiSelect}
        />
      </div>
    </FocusOn>
  );
};

EmojiPickerWrapper.propTypes = {
  closePicker: PropTypes.func,
  isActive: PropTypes.bool,
  onEmojiSelect: PropTypes.func,
  target: PropTypes.instanceOf(Element),
};

export default EmojiPickerWrapper;
